import React, { useMemo } from "react";
import { View } from "react-native";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { style as pillStyle } from "./Pill.style";
const Pill = ({ label, style: customStyle, onPress }) => {
    const style = useMemo(() => pillStyle(), []);
    return (React.createElement(View, { style: [style.container, customStyle], testID: "pill" },
        React.createElement(Text, { level: 1, style: style.text, variant: "detail" }, label),
        React.createElement(ButtonIcon, { name: "close_small", style: { icon: style.icon }, testID: "pill-button-icon", onPress: onPress })));
};
export { Pill };
